import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const ArrowDownTraySvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return (
    <div {...props}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8 2.5V10.5M8 10.5L5.5 8M8 10.5L10.5 8M3 12.5H13"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}

export default ArrowDownTraySvg
